import { useMutation } from '@tanstack/react-query';

import {
  type MutationFunction,
  type BomStructureFileSuggestion,
  useRequest,
} from '@frontend/api';

export type GetBulkBomStructureResponseBody = Array<BomStructureFileSuggestion>;

export type GetBulkBomStructureRequestBody = {
  uuids: string[];
};

export type GetBulkBomStructureQueryKeyType = readonly ['bomBuilderStructure'];

const getBulkGetBomStructureQueryKey = (): GetBulkBomStructureQueryKeyType => [
  'bomBuilderStructure',
];

export const useGetBomStructure: MutationFunction<
  BomStructureFileSuggestion[],
  GetBulkBomStructureRequestBody,
  []
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const mutationKey = getBulkGetBomStructureQueryKey();

  return useMutation({
    mutationFn: (body) => {
      return request('/parts/files/bulk_bom_structure', {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    ...queryOptions,
    mutationKey,
  });
};
